import { PlayerSettings, SettingsQuestions } from '../model/player.settings';

export class PlayerSettingsUtil {
  static hasSettingsQuestionBeenDismissed(settings: PlayerSettings, settingsQuestion: SettingsQuestions): boolean {
    return settings.settingsQuestionsDismissed.find((setting) => setting == settingsQuestion) != null;
  }
}
